import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const ClerkMode = loadable(() => import('./ClerkMode'), {
  fallback: <LoadingScreen />,
});

export default ClerkMode;
